import { usePlanGroup } from '../queries/usePlanGroup';

const DEFAULT_CURRENCY = 'USD';
const DEFAULT_COUNT = 0;

export const useIs3PLCustomer = () => {
  const { data, isLoading, error } = usePlanGroup(DEFAULT_CURRENCY, DEFAULT_COUNT);

  return { is3PLCustomer: data?.is3PLCustomer(), isTrialer: data?.isTrialer(), isLoading, error };
};
